import { forwardRef } from "react";
import styles from "./DreamforceAnnouncementBar.module.css";
import Link from "next/link";

interface Props {
  show: boolean;
  onClose: () => void;
  onMeetUsClick: () => void;
}

const DreamforceAnnouncementBar = forwardRef<HTMLDivElement, Props>(
  ({ show, onClose }, ref) => {
    if (!show) return null;

    const ctaRef =
      "https://www.trootech.com/case-studies/ai-clinical-trial-discovery-platform";

    return (
      <div
        ref={ref}
        className={styles.bar}
        role="region"
        aria-label="Case study announcement"
      >
        <span className={styles.caseStudyIcon} aria-hidden="true">
          <img src="/images/case-study-icon.svg" alt="" />
        </span>

        <p className={`${styles.text} ${styles.textDesktop}`}>
          Recently Delivered: An AI-Powered Clinical Trial Discovery Platform |{" "}
          <Link
            href={ctaRef}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Explore the Case Study
          </Link>
        </p>

        <p className={`${styles.text} ${styles.textMobile}`}>
          <span className={styles.mobileLine}>
            Recently Delivered: An AI-Powered Clinical Trial Discovery Platform |{" "}
            <Link
              href={ctaRef}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Explore the Case Study
            </Link>
          </span>
        </p>

        <button
          type="button"
          className={styles.close}
          aria-label="Dismiss announcement"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
    );
  },
);

DreamforceAnnouncementBar.displayName = "DreamforceAnnouncementBar";

export default DreamforceAnnouncementBar;